<script>
  export var onSubmit;
  export var asLink = "";
  export var disabled = false;
  export var showText = true;
  export var showIcon = false;
  export var text = "Save";
  export var textSaving = "Saving...";
  export var textSaved = "Saved!";
  export var textError = "Error!";
  var updating;
  var result;

  async function submit() {
    updating = true;
    try {
      result = await onSubmit();
    } catch (err) {
      updating = false;
      throw err;
    }
    updating = false;

    setTimeout(() => (result = null), 3000);
  }
</script>

<button
  class="btn btn-outline"
  class:btn-danger={result === false}
  class:btn-link={asLink}
  {disabled}
  on:click|preventDefault={() => submit()}>
  {#if updating}
    <svg class="icon spin" class:hidden={!showIcon}>
      <use href={'/icons.svg#circle_notch'} />
    </svg>
    {#if showText}{textSaving}{/if}
  {:else if result === true}
    <svg class="icon" class:hidden={!showIcon}>
      <use href={'/icons.svg#check'} />
    </svg>
    {#if showText}{textSaved}{/if}
  {:else if result === false}
    <svg class="icon" class:hidden={!showIcon}>
      <use href={'/icons.svg#warning'} />
    </svg>
    {#if showText}{textError}{/if}
  {:else}
    <svg class="icon" class:hidden={!showIcon}>
      <use href={'/icons.svg#save'} />
    </svg>
    {#if showText}{text}{/if}
  {/if}
</button>
